import { poll } from 'lib/poll';
import { SelfServiceAPI } from 'apis';

const createCancellationQuote = async (bookingId: string) => {
  const createResult = await SelfServiceAPI.createCancellation(bookingId);
  const cancellationId = createResult.id;

  if (!cancellationId) {
    throw Error('Missing cancellation id');
  }

  const quotedResult = await poll({
    requestFn: () => SelfServiceAPI.getCancellation({ bookingId, cancellationId }),
    isFinished: (result) => result.cancellation.state !== 'QUOTING',
  });

  if (quotedResult.cancellation.state !== 'QUOTED') {
    throw Error(`Unexpected cancellation state "${quotedResult.cancellation.state}"`);
  }

  return quotedResult.cancellation;
};

export default createCancellationQuote;
